import { createAction, props } from '@ngrx/store';

export const loadUserMenus = createAction('[PermissionMenus] Load User Menus');
export const loadUserMenusSuccess = createAction(
  '[PermissionMenus] Load User Menus Success',
  props<{ menus: any[] }>()
);
export const loadUserMenusFailure = createAction(
  '[PermissionMenus] Load User Menus Failure',
  props<{ error: any }>()
);
